(() => {
  class LinkedProducts extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.imageSwatchLabel = this.querySelector('.linked-option-product-title');
      this.imageSwatches = this.querySelectorAll('.swatch-element.image-swatch');
      this.imageCache = new Map();
      this.previewToken = 0;
      this.hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
      const options = { signal: this.controller.signal };
      this.closest('[data-product-content-wrapper]')?.addEventListener('sobro:swatch-preview', event => {
        if (event.detail !== this) this.restore();
      }, options);
      this.hoverMedia.addEventListener('change', () => this.restore(), options);
      this.imageSwatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', () => {
          if (this.hoverMedia.matches) this.preview(swatch);
        }, options);
        swatch.addEventListener('mouseleave', () => {
          const focused = this.querySelector('.sobro-swatch-link:focus-visible');
          if (focused) this.preview(focused.closest('.swatch-element'));
          else this.restore();
        }, options);
      });
      this.addEventListener('focusin', event => {
        if (event.target.matches('.sobro-swatch-link:focus-visible')) {
          this.preview(event.target.closest('.swatch-element'));
        }
      }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) this.restore();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.restore();
      }, options);
      this.addEventListener('click', () => this.restore(), options);
      this.classList.add('sobro-swatches-ready');
      this.restore();
    }

    updateSwatchLabel(swatch) {
      if (this.imageSwatchLabel) this.imageSwatchLabel.textContent = swatch?.dataset.value || '';
    }

    loadImage(source) {
      if (!this.imageCache.has(source)) {
        const promise = new Promise((resolve, reject) => {
          const image = new Image();
          image.decoding = 'async';
          image.onload = () => resolve(image);
          image.onerror = reject;
          image.src = source;
        });
        this.imageCache.set(source, promise);
      }
      return this.imageCache.get(source);
    }

    preview(swatch) {
      this.clearPreview();
      this.closest('[data-product-content-wrapper]')?.dispatchEvent(new CustomEvent('sobro:swatch-preview', { detail: this }));
      this.updateSwatchLabel(swatch);
      if (!swatch || swatch.classList.contains('active') || !swatch.dataset.previewImage) return;
      const token = this.previewToken;
      this.previewTimer = window.setTimeout(async () => {
        try {
          const image = await this.loadImage(swatch.dataset.previewImage);
          if (token !== this.previewToken || !this.isConnected) return;
          const root = this.closest('[data-product-content-wrapper]');
          const galleries = root?.querySelectorAll('[data-media-main]') || [];
          const gallery = Array.from(galleries).find(item => item.getBoundingClientRect().width > 0);
          const host = gallery?.querySelector('.swiper-slide-active [data-main-media-link]')
            || gallery?.querySelector('[data-main-media-link]');
          if (!host) return;
          this.previewHost = host;
          this.previewGallery = gallery.closest('product-media-grid, product-media') || gallery;
          this.previewLayer = document.createElement('span');
          this.previewLayer.className = 'sobro-preview-layer';
          this.previewLayer.setAttribute('aria-hidden', 'true');
          const previewImage = image.cloneNode();
          previewImage.alt = '';
          this.previewLayer.append(previewImage);
          if (this.dataset.previewLabel) {
            const caption = document.createElement('span');
            caption.className = 'sobro-preview-caption';
            caption.textContent = this.dataset.previewLabel + (swatch.dataset.previewStatus ? ' · ' + swatch.dataset.previewStatus : '');
            this.previewLayer.append(caption);
          }
          host.classList.add('sobro-preview-host');
          this.previewGallery.classList.add('sobro-preview-gallery');
          host.append(this.previewLayer);
        } catch {
          if (token === this.previewToken) this.restore();
        }
      }, 65);
    }

    clearPreview() {
      this.previewToken += 1;
      window.clearTimeout(this.previewTimer);
      this.previewLayer?.remove();
      this.previewHost?.classList.remove('sobro-preview-host');
      this.previewGallery?.classList.remove('sobro-preview-gallery');
      this.previewLayer = null;
      this.previewHost = null;
      this.previewGallery = null;
    }

    restore() {
      this.clearPreview();
      this.updateSwatchLabel(this.querySelector('.swatch-element.image-swatch.active'));
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.clearPreview();
      this.imageCache?.clear();
    }
  }
  if (!window.customElements.get('linked-products')) window.customElements.define('linked-products', LinkedProducts);
})();
